<script setup lang="ts">
type DialogBannerVariant = 'success' | 'promo';

withDefaults(defineProps<{ variant?: DialogBannerVariant }>(), { variant: 'success' });
</script>

<template>
  <div
    :class="[
      'text-md md:text-base flex min-h-16 shrink-0 items-center gap-md px-md py-sm md:px-content',
      $slots.action && 'flex-wrap justify-between',
      variant === 'success' && 'bg-green text-green',
      variant === 'promo' && 'bg-surface-tint text-tint',
    ]"
  >
    <div class="flex min-w-0 items-center gap-md">
      <slot name="icon" />
      <slot />
    </div>
    <div v-if="$slots.action" class="shrink-0">
      <slot name="action" />
    </div>
  </div>
</template>
